import TextArea from "antd/lib/input/TextArea";

export { TextArea };
